module.exports = __webpack_public_path__ + "img/shouye.78edac8f.png";